import { render, staticRenderFns } from "./lateral.vue?vue&type=template&id=2e8988b0&scoped=true"
import script from "./lateral.vue?vue&type=script&lang=js"
export * from "./lateral.vue?vue&type=script&lang=js"
import style0 from "./lateral.vue?vue&type=style&index=0&id=2e8988b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8988b0",
  null
  
)

export default component.exports